<script setup lang="ts">

</script>

<template>
  <li>
    <div class="photo">
      <img src="/images/kv.jpg" alt="Ващенков Константин"/>
    </div>
    <p class="name">Ващенков Константин</p>
    <p class="position">технический директор XSQUARE</p>
  </li>
</template>

<style scoped lang="scss">

</style>